/**
 * Admin dashboard helpers — re-exports from central API utility.
 * All fetch calls go through apiFetch which NEVER uses credentials: 'include'.
 */
import { API_BASE, apiFetch } from '@/lib/api';

export const API = API_BASE;
export const authFetch = apiFetch;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('elevatemn_session');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const exportCSV = async (type) => {
  const res = await apiFetch(`${API}/export/${type}`);
  const data = await res.json();
  const blob = new Blob([data.csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = data.filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
